import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationPlaceItemInHeroInventoryArgs,
  ItemMoveResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation PlaceItemInHeroInventory(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  placeItemInHeroInventory(
    playerId: $playerId
    itemId: $itemId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export default async function mutationPlaceItemInHeroInventory(
  args: MutationPlaceItemInHeroInventoryArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>('placeItemInHeroInventory', mutation, args);
}
